<template>
  <div>
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 7.5px 10px;
      "
    >
      <button
        class="btn"
        style="font-size: 16px; color: #6c6c6c; padding: 4px"
        @click="$router.go(-1)"
      >
        <i class="fas fa-angle-left mr-2"></i>
        Back
      </button>
      <p class="mb-0" style="font-size: 16px; color: #b9b9b9; font-weight: 600">
        | Part Maker App
        <i class="fas fa-angle-right"></i>
      </p>
      <p
        class="mb-0 ml-1"
        style="font-size: 16px; color: #4b4b4b; font-weight: bold"
      >
        {{ mode === "CREATE" ? "Create" : "Edit" }} User
      </p>
    </div>

    <!-- Your content goes here -->
    <form>
      <div class="innerBox col mt-4">
        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Username</label>
          </div>
        </div>

        <div v-if="mode === 'CREATE'" class="row">
          <div class="col-12">
            <input
              type="text"
              v-model="form.username"
              class="searchbar"
              placeholder="Username"
            />
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12">
            <input
              type="text"
              v-model="form.username"
              class="searchbar"
              placeholder="Username"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Password</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <input
              type="text"
              v-model="form.password"
              class="searchbar"
              placeholder="Password"
            />
          </div>
        </div>

        <!-- Type field start -->
        <!-- v-if="mode === 'CREATE'" -->
        <!-- <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Type</label>
          </div>
        </div> -->

        <!-- v-if="mode === 'CREATE'" -->
        <!-- <div class="row">
          <div class="col-12"> -->
        <!-- <input
                  type="text"
                  v-model="form.type"
                  class="searchbar"
                  placeholder="Type"
                /> -->
        <!-- <select v-model="form.role" class="searchbar">
              <option disabled value="">Select Type</option>
              <option v-for="role in roles" :key="role.name" :value="role.name">
                {{ role.name }}
              </option> -->
        <!-- <option value="SUPER ADMIN">SUPER ADMIN</option>
              <option value="ADMIN">ADMIN</option> -->
        <!-- </select>
          </div>
        </div> -->
        <!-- Type field end -->

        <!-- AHM product field start -->
        <!-- <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">AHM Product</label>
          </div>
        </div> -->

        <!-- <div class="d-inline-block searchbar"> -->
        <!-- <label class="typo__label">Select Product Type</label> -->
        <!-- <multiselect
            v-model="value"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Product Type"
            label="name"
            track-by="name"
            :preselect-first="true"
            :disabled="isSuperAdmin"
          >
            <template #selection="{ values, search, isOpen }">
              <span
                class="multiselect__single"
                v-if="values.length"
                v-show="!isOpen"
                >{{ values.length }} options selected</span
              >
            </template>
          </multiselect> -->
        <!-- <pre class="language-json"><code>{{ value }}</code></pre> -->
        <!-- </div> -->
        <!-- AHM product field end -->

        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Status</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <select v-model="form.status" class="searchbar">
              <option disabled value="">Select Status</option>
              <option value="ACTIVE">ACTIVE</option>
              <option value="INACTIVE">INACTIVE</option>
            </select>
          </div>
        </div>

        <div class="filter row mt-5">
          <div class="col-lg-2 col-md-6">
            <button
              type="button"
              class="btn btn-primary w-100"
              style="font-size: 100%"
              @click="submitForm()"
            >
              {{ mode == "CREATE" ? "Create User" : "Update User" }}
            </button>
          </div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import router from "../../../Options/router";
import axios from "axios";
// import DateRangePicker from 'vue-daterange-picker';

export default {
  metaInfo: {
    title: "Create User",
  },
  data() {
    return {
      matched_id: null,
      filledUsername: "",
      user: this.$store.getters.currentUser,
      value: [],
      options: [],
      roles: [],
      mode: "CREATE",
      updateId: null,
      form: {
        username: "",
        password: "",
        role: "",
        product_category: [],
        status: "",
      },
    };
  },
  components: { Multiselect },
  computed: {
    isSuperAdmin() {
      return this.roles.some(
        (role) => role.name === "SUPER ADMIN" && this.form.role === role.name
      );
    },
  },
  mounted: async function () {
    let routerName = this.$route.name;
    let editData = this.$route.params.data;
    // console.log("Update route data:", editData);

    await this.fetchFeedData();

    if (routerName == "UPart") {
      if (editData != null) {
        this.mode = "UPDATE";
        this.form.role = editData.roles;
        this.form.status = editData.status === "ACTIVE" ? 1 : 0;

        if (editData.product_category) {
          const productItems = editData.product_category.split(", ");
          const result = productItems.map((item) => ({ name: item }));

          this.value = result;

          const matchedItems = this.value
            .map((product) => {
              return this.options.find(
                (option) => option.name === product.name
              );
            })
            .filter((match) => match !== undefined);

          this.value = [...matchedItems];
        }

        this.updateId = editData.id;
        this.form.username = editData.username;
        this.form.status = editData.status;
      } else {
        //No Data, No View Page
        this.$router.go(-1);
      }
    }
  },
  watch: {
    options(newVal) {
      if (newVal.length > 0) {
        console.log("Options from watcher:", newVal[0]);
        // this.processOptions(newVal[0]); // Call another method with the updated value
      }
    },
    // roles(newRole) {
    //   if (newRole === "SUPER ADMIN") {
    //     // Add all product IDs to product_category
    //     this.form.product_category = this.options.map((product) => product.id);
    //   } else {
    //     // Clear product_category when not SUPER ADMIN
    //     this.form.product_category = [];
    //   }
    // },
  },
  methods: {
    async fetchFeedData() {
      try {
        // const token = this.user.token;
        // const headers = {
        //   Authorization: `Bearer ${token}`,
        // };

        // const endpoints = [
        //   "/api/admin/feeds/product-category",
        //   `/api/admin/feeds/roles`, // cari env
        // ];

        // const resps = await Promise.all(
        //   endpoints.map((url) => this.$httpSSO.get(url, { headers }))
        // );

        // const productCategories = resps[0].data.data.map((prod) => ({
        //   id: prod.id,
        //   name: prod.name,
        // }));

        // const roles = resps[1].data.data.map((role) => ({
        //   name: role.name,
        // }));

        // this.options.push(...productCategories);
        // this.roles.push(...roles);
        // const resp = await ("");
        console.log("Update id:", this.updateId);

        this.$http("/user-partmaker/update" + this.updateId).then((resp) =>
          console.log("API Update response:", resp)
        );
      } catch (error) {
        console.error("Error fetching product category feeds", error);
      }
    },
    goBack() {
      this.$router.go(-1); // Go back to the previous route
    },
    performSearch() {
      // Implement your search logic here using this.searchQuery
      // For example, you can filter your data based on the search query
    },
    validateForm() {
      let errors = [];

      // if (this.form.product_category.length === 0) {
      //   errors.push("<strong>Product type</strong> is a required field!");
      // }

      if (errors.length > 0) {
        this.$swal.fire({
          title: "Error!",
          icon: "error",
          type: "error",
          html: errors.join("<br>"),
        });
        console.log("errors:", errors);
        return false;
      } else {
        console.log("errors:", errors);
        return true;
      }
    },
    submitForm() {
      const token = this.user.token;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      if (this.form.role === "SUPER ADMIN") {
        this.form.product_category = this.options.map((product) => product.id);
      } else {
        const productsId = this.value.map((product) => product.id);
        this.form.product_category = productsId;
      }

      if (this.form.role === "SUPER ADMIN" || this.validateForm()) {
        this.$swal
          .fire({
            title: "Are you sure?",
            text: `You are about to ${
              this.mode == "CREATE" ? "make a new" : "edit current"
            } data`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#D33",
            confirmButtonText: "Simpan",
          })
          .then((result) => {
            if (result.value) {
              let url =
                this.mode == "CREATE"
                  ? "/user-partmaker/create"
                  : "/user-partmaker/update/" + this.updateId; // Fix the typo here
              let method = this.mode == "CREATE" ? "post" : "put";

              this.$http[method](url, this.form)
                .then((resp) => {
                  this.$swal.fire({
                    title: "Success!",
                    icon: "success",
                    type: "success",
                    text: `${
                      this.mode == "CREATE"
                        ? "Berhasil menambahkan user baru"
                        : "Berhasil melakukan update"
                    }`,
                  });
                  this.$router.go(-1); // Go back to the previous route
                })
                .catch((error) => {
                  console.log(
                    "%cerror DashboardUserUM.vue line:78 ",
                    "color: red; display: block; width: 100%;",
                    error
                  );
                  this.$swal.fire({
                    title: "Error!",
                    icon: "error",
                    type: "error",
                    text: error.response.data.message,
                  });
                });
            }
          });
      }
    },
  },
};
</script>

<style scoped>
/* .dropdown-menu {
  width: auto; /* Ensures the width adapts
} */
/* max-width: 300px; Optional: Limit maximum width */

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  padding-left: 40px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #4d4d4d;
}

/* .center {
          padding: 50px 20px;
          display: flexbox;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%;
  /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left;
  /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left;
  /* To position the news-content on the bottom right */
}

.search-container {
  display: flex;
  align-items: center;
}

.dropdown-container {
  flex: 1;
  margin-right: 10px;
}

.searchbar-container {
  flex: 2;
}

.dropdown {
  width: 100%;
}

.searchbar {
  width: 50%;
  padding: 5px;
}
</style>
